import {
  IOrderFunctions,
  OrderTableSearchParam,
  OrderType,
} from "../../../Interfaces/orderInterfaces";
import OrderTable from "../../../Tables/Order/OrderTable/OrderTable";
import TabBox from "../../../Components/Tabbox/TabBox";
import { useState } from "react";
import { useErrorTabCount } from "src/Hooks/useErrorTabCount";
import TradeTable from "../../../Tables/Trade/TradeTable";
import ErrorsTable from "../../../Tables/Order/ErrorsTable/ErrorsTable";
import OrderPageTablesSearchParamUI from "./OrderPageTablesSearchParamUI";
import { getErrorsTable } from "../../../Requests/Order/orderRequests";
import OrderBookPairWrapper from "./OrderBookPairWrapper";

export enum OrderTablesTabIndex {
  AggregationTable = 1,
  OrderTable = 2,
  TradeTable = 3,
  ErrorsTable = 4,
}

interface OrderResultProps {
  orderType: OrderType;
  orderFunctions: IOrderFunctions;
}

const OrderResult = ({ orderType, orderFunctions }: OrderResultProps) => {
  const [tabIndex, setTabIndex] = useState(OrderTablesTabIndex.OrderTable);

  const [tablesSearchParam, setOrderTradeSearchParam] =
    useState<OrderTableSearchParam>({} as OrderTableSearchParam);

  const { errorTabCount, errorTableRefreshFlag, errorTableAfterFetchHandler } =
    useErrorTabCount(
      `order${orderType}`,
      tabIndex,
      OrderTablesTabIndex.ErrorsTable,
      (searchParam, offset, pageSize) =>
        getErrorsTable(searchParam, offset, pageSize, orderFunctions)
    );

  const onTablesSearchParamChange = (name: string, value: any) => {
    setOrderTradeSearchParam({ ...tablesSearchParam, [name]: value });
  };

  const tablesTabsChildren = [
    { index: OrderTablesTabIndex.OrderTable, title: "سفارشات" },
    { index: OrderTablesTabIndex.TradeTable, title: "معاملات" },
    {
      index: OrderTablesTabIndex.ErrorsTable,
      title: "خطا",
      count: errorTabCount,
    },
  ];

  const getTabIndexTable = () => {
    switch (tabIndex) {
      case OrderTablesTabIndex.OrderTable:
        return (
          <OrderTable
            searchParam={tablesSearchParam}
            orderType={orderType}
            orderFunctions={orderFunctions}
          />
        );

      case OrderTablesTabIndex.TradeTable:
        return (
          <TradeTable
            searchParam={tablesSearchParam}
            orderType={orderType}
            orderFunctions={orderFunctions}
          />
        );
      case OrderTablesTabIndex.ErrorsTable:
        return (
          <ErrorsTable
            getData={(searchParam, offset, pageSize) =>
              getErrorsTable(searchParam, offset, pageSize, orderFunctions)
            }
            searchParams={tablesSearchParam}
            onFetchComplete={errorTableAfterFetchHandler}
            refreshFlag={errorTableRefreshFlag}
          />
        );
    }
  };

  return (
    <div className="w-full flex flex-col gap-3">
      <OrderBookPairWrapper orderType={orderType} />
      <div className="w-full border-t-2 border-gray-300 mt-3 pt-5">
        <div className="max-w-min m-auto">
          <div className="w-full flex flex-row justify-between items-center">
            <div className="max-w-min">
              <TabBox
                activeTab={tabIndex}
                children={tablesTabsChildren}
                onChange={(_, index) => setTabIndex(index)}
              />
            </div>
            <OrderPageTablesSearchParamUI
              onChange={onTablesSearchParamChange}
              searchParams={tablesSearchParam}
            />
          </div>
          <div className="w-full">{getTabIndexTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default OrderResult;
